import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
const { API_URLBLAZE } = environment;


export interface FxCurrency {
    currencyName: string;
    currencyCode: string;
}


@Injectable({
    providedIn: 'root'
})
export class FxService {

    constructor(private http: HttpClient) { }

    getFxCurrencyList(): Observable<FxCurrency[]> {
        return this.http.get<FxCurrency[]>(`${API_URLBLAZE}/forex-exchange/api/currency`);
        // return this.http.get<FxCurrency[]>(`https://globalapi.pay10.com/forex-exchange/api/currency`);
    }


    getFxMerchantList(): Observable<string[]> {
        return this.http.get<string[]>(`${API_URLBLAZE}/forex-exchange/api/merchants`);
        // return this.http.get<string[]>(`https://globalapi.pay10.com/forex-exchange/api/merchants`);
    }

    getFxTransactionList(params: any) {
        return this.http.post<any>(`${API_URLBLAZE}/forex-exchange/api/v1/reports/fx-transactions`, params);
        // return this.http.post<any>(`https://globalapi.pay10.com/forex-exchange/api/v1/reports/fx-transactions`, params);
    }

    // fx-service.ts
    getFxTransactionAuditTrail(params: string) {
        // return this.http.get<any>(
        //     `https://globalapi.pay10.com/forex-exchange/api/v1/reports/fx-transactions/audit-trail/${params}`
        // );
        return this.http.get<any>(
            `${API_URLBLAZE}/forex-exchange/api/v1/reports/fx-transactions/audit-trail/${params}`
        );
    }

}